// PUBLIC PAGES
const LANDING_PAGE_URL = '/';
const LOGIN_PAGE_URL = '/login';
const USER_PROFILE_PAGE_URL = '/user-profile';
const USER_RECOMMENDATIONS = '/recommendations';
const REGISTER_PAGE_URL = '/signup';
const ABOUT_US_PAGE_URL = '/about';
const CONTACT_US_PAGE_URL = '/contact-us';
const PRIVACY_POLICY_PAGE_URL = '/privacy';
const FAQ_PAGE_URL = '/FAQ';
const TC_PAGE_URL = '/terms-and-conditions';
const LOAN_REQUEST_PAGE_URL = '/loan-request';
const PAGE_404 = '/404';
const COMING_SOON_URL = '/coming-soon';
const INVESTOR_DASHBOARD = '/investordashboard';
const FUNDEE_DASHBOARD_PAGE_URL = '/fundee-dashboard';
const COMPAIGN_PAGE_URL = '/campaign';
const ADMIN_DASHBOARD_PAGE_URL = '/admin-dashboard';
const ADMIN_FAQ_PAGE_URL = '/admin-dashboard/add-faq';
const ADMIN_CAMPAIGN_PAGE_URL = '/admin-dashboard/campaign';
const ADMIN_FUNDING_PAGE_URL = '/admin-dashboard/funding';
const ADMIN_PAYMENT_PAGE_URL = '/admin-dashboard/payment';
const ADMIN_SETTINGS_PAGE_URL = '/admin-dashboard/settings';
const BLOG_PAGE_URL = '/blog';
const DEFAULT_DASHBOARD_PAGE_URL = '/default-dashboard';
const PAYMENT_PAGE_URL = '/payment';
const PAYMENT_OTP_PAGE_URL = '/payment-otp';
const PAYMENT_SUCCESS_PAGE_URL = '/payment-success';
const INVITE_RECOMMENDER_PAGE_URL = '/invite-recommender';
const EMAIL_VERIFICATION_URL = '/email-confirmation-success';
const EMAIL_CONFIRMATION_FAILURE_URL = '/email-confirmation-failure';
const EMAIL_CONFIRMATION_URL = '/email-confirmation';
const SINGLE_POST_URL = '/blog/post';
const CREATE_NEW_POST_URL = '/create-new-post';
const EDIT_PROFILE = '/edit-profile';
const RESET_PASSWORD_URL = '/reset-password';
const FUND_A_CAMPAIGN = '/campaigns';
const VERIFICATION_FORM2_URL = '/verification-form2';
const VERIFICATION_3 = '/verification3';
const VERIFICATION_FORM_ONE = '/verification-form-one';

const pageurl = {
  LANDING_PAGE_URL,
  LOGIN_PAGE_URL,
  USER_PROFILE_PAGE_URL,
  USER_RECOMMENDATIONS,
  REGISTER_PAGE_URL,
  ABOUT_US_PAGE_URL,
  CONTACT_US_PAGE_URL,
  PRIVACY_POLICY_PAGE_URL,
  FAQ_PAGE_URL,
  TC_PAGE_URL,
  LOAN_REQUEST_PAGE_URL,
  PAGE_404,
  COMING_SOON_URL,
  INVESTOR_DASHBOARD,
  FUNDEE_DASHBOARD_PAGE_URL,
  COMPAIGN_PAGE_URL,
  ADMIN_DASHBOARD_PAGE_URL,
  ADMIN_FAQ_PAGE_URL,
  ADMIN_CAMPAIGN_PAGE_URL,
  ADMIN_FUNDING_PAGE_URL,
  ADMIN_PAYMENT_PAGE_URL,
  ADMIN_SETTINGS_PAGE_URL,
  BLOG_PAGE_URL,
  DEFAULT_DASHBOARD_PAGE_URL,
  PAYMENT_PAGE_URL,
  PAYMENT_OTP_PAGE_URL,
  PAYMENT_SUCCESS_PAGE_URL,
  INVITE_RECOMMENDER_PAGE_URL,
  EMAIL_VERIFICATION_URL,
  EMAIL_CONFIRMATION_FAILURE_URL,
  EMAIL_CONFIRMATION_URL,
  SINGLE_POST_URL,
  CREATE_NEW_POST_URL,
  EDIT_PROFILE,
  RESET_PASSWORD_URL,
  FUND_A_CAMPAIGN,
  VERIFICATION_FORM2_URL,
  VERIFICATION_3
};

export default pageurl;
